
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import router from "@/router";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      Content: "getContent",
      Affiliate: "getAffiliate",
      getQuestionnaireTypeProducts: "getQuestionnaireTypeProducts",
      getSiteSetupTimeStamp: "getSiteSetupTimeStamp",
    }),
  },
  watch: {
    Content() {
      this.GetStarted();
    },
  },
  mounted() {
    this.GetStarted();
  },
  methods: {
    ...mapMutations({ setCurrentQuestType: "setCurrentQuestType", setShowCart: "setShowCart" }),
    GetStarted() {
      if (this.getSiteSetupTimeStamp) {
        if (router.currentRoute.path != "/") return;
        if (this.Content) {
          const siteHomepage = this.Content.SiteHomepage;
          if (!siteHomepage || (siteHomepage == "/" && this.Affiliate?.rootQuestionnaireTypeID)) {
            this.LoadQuestionnaire(this.Affiliate.rootQuestionnaireTypeID);
            return;
          }

          if (router.currentRoute.name == siteHomepage) return;

          this.$router.replace({ name: siteHomepage, query: this.$route.query }).catch();
        }
      }
    },
    LoadQuestionnaire(t: number) {
      this.setCurrentQuestType(t);
      router.push("/questionnaire");
    },
  },
});
